export function NectarliquidLogo() {
  return (
    <svg width="280" height="265" viewBox="0 0 280 265" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1439_11901)">
        <path
          d="M123.994 108.787C113.349 70.1351 83.8798 109.992 84.0004 149.958C84.1209 189.925 102.199 180.376 105.485 146.34C108.771 112.303 117.563 107.818 123.091 125.722C131.472 152.872 128.826 126.328 123.994 108.787Z"
          fill="url(#paint0_linear_1439_11901)"
        />
        <path
          d="M112.031 101.619C104.262 101.333 97.1888 109.274 92.159 117.038C88.7373 122.319 86.3225 128.905 85.1819 136.189C84.4762 140.699 84.0923 145.332 84.1068 149.968C84.2272 189.914 102.285 180.37 105.567 146.351C108.849 112.332 117.631 107.849 123.153 125.744C124.534 130.216 125.612 133.219 126.433 135.058C124.797 120.231 120.968 101.948 112.034 101.614L112.031 101.619Z"
          fill="url(#paint1_linear_1439_11901)"
        />
        <path
          d="M117.787 154.283C130.542 200.688 188.498 158.132 194.449 111.573C200.399 65.0148 167.143 73.7681 156.118 112.975C145.093 152.181 128.944 156.254 121.986 134.68C111.437 101.966 111.996 133.224 117.787 154.283Z"
          fill="url(#paint2_linear_1439_11901)"
        />
        <path
          d="M137.837 164.251C151.467 165.603 165.142 157.277 175.193 148.891C182.03 143.186 187.296 135.829 190.428 127.492C192.366 122.33 193.756 116.981 194.446 111.578C200.396 65.0197 167.14 73.773 156.115 112.98C145.09 152.186 128.941 156.259 121.983 134.685C120.242 129.293 118.808 125.652 117.648 123.402C118.239 140.893 122.158 162.697 137.831 164.257L137.837 164.251Z"
          fill="url(#paint3_linear_1439_11901)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1439_11901"
          x="0"
          y="0"
          width="279.156"
          height="264.117"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="42" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.92549 0 0 0 0 0.592157 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1439_11901" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1439_11901" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_1439_11901"
          x1="141.132"
          y1="98.3156"
          x2="69.8725"
          y2="115.394"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00EC97" />
          <stop offset="1" stopColor="#0FCF8A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1439_11901"
          x1="138.844"
          y1="106.229"
          x2="71.361"
          y2="123.053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00EC97" />
          <stop offset="1" stopColor="#0FCF8A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1439_11901"
          x1="222.795"
          y1="90.0936"
          x2="98.7137"
          y2="117.814"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00EC97" />
          <stop offset="1" stopColor="#0FCF8A" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1439_11901"
          x1="221.446"
          y1="89.0352"
          x2="104.137"
          y2="116.901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00EC97" />
          <stop offset="1" stopColor="#0FCF8A" />
        </linearGradient>
      </defs>
    </svg>
  );
}
